module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cannotAssignRole":"You may not edit your own Project Role.","field":{"projectRole":"Project Role"}}}')
  delete Component.options._Ctor
}
